import { EMPTY } from "./Constants";
import OEIInput from "./OEIInput";

export default function AddNewEmailModel(props) {
    return (<>
        {props.email ?

<div className={`${props.type==='new'?'sub-windows-host5':'sub-windows-host6'}`}>

  <div class="oe-popup-layout oe-popup-layout--popover position--fix">
    <div class="oe-popup-layout__body" style={{ padding: '0px 5px' }}>
      <OEIInput value={props.emailId} setValue={props.setEmailid} name='firstName' label='Email address' errorMessage={props.error} setErrorMessage={props.setError} showError='false'></OEIInput>
       {props.newData.selectedValue === 'Event Edited' ||props.editData.notificationType === "Event Updated" ||props.editData.notificationType === "Event status changed"  ||props.newData.selectedValue === "Event status changed"||(props.newData.selectedValue==='Artifacts Issue Alert') ||props.editData.notificationType === "Artifacts Issue Alert"||(props.newData.selectedValue==='Artifacts Delivered') ||props.editData.notificationType === "Artifacts Delivered" ||(props.newData.selectedValue==='Registration failed')||props.editData.notificationType === "Registration failed"?
        <div className="m-top-10px m-bottom-0px display">
          <label style={{ color: '#1A1A1A' }} className="switch">
            <input type="checkbox" checked={props.toggeleChecked} onChange={props.onChangeToggle} value={`${props.toggeleChecked ? 'Sends to this email address aswell as project managers' : '-'}`} />
            <span className="slider round "></span>
          </label>
          <span className="line-height-12px">{`${props.toggeleChecked ? 'This email address and project managers will receive all the emails' : 'This email address will only receive notifications if no project manager is assigned'}`} </span> {props.errorMessage !== EMPTY ? <div className="oe-form-field__error">{props.errorMessage}</div> : EMPTY}
        </div> : <></>}
    </div>
    <div class="oe-popup-layout__footer">
      <div class="buttons-block buttons-block--from-right">
        <button type="button" onClick={props.addEmail} class="default-button default-button--fat default-button--confirm-safe">
          <span>Add</span>
        </button>
        <button type="button" onClick={props.cancelEmailAdding} class="default-button default-button--cancel default-button--fat">
          <span>Cancel</span>
        </button>
      </div>
    </div>
  </div>
</div>
: EMPTY
}
    </>)
}